import React from 'react';
//import '../../App.css'; // Import App.css for footer styling

const Footer = () => (
  <footer role="contentinfo-footer">
    <div className="container-footer">
      <p>
        © SAHASH 2025 | Privacy Policy | Refund/Cancellation Policy |{' '}
        +91 9473795690 |{' '}
        <a href="mailto:info@sahashindia.org" rel="noopener">
          info@sahashindia.org
        </a>
      </p>
    </div>
  </footer>
);

export default Footer;